import { IInvoice } from '../interfaces';
import { useTranslation } from 'react-i18next';

// Function to get set fields and placeholder depends on what fields are field in invoice

const getFormFields = (customer: Partial<IInvoice['customer']>) => {
    const { t } = useTranslation();
    const { email, phone_number } = customer;

    if (!email && !phone_number) {
        return [
            {
                name: 'email',
                placeholder: t('enter_email')
            },
            {
                name: 'phone_number',
                placeholder: t('enter_number')
            }
        ];
    }

    if (!email && phone_number) {
        return [
            {
                name: 'email',
                placeholder: t('enter_email')
            }
        ];
    }

    if (email && !phone_number) {
        return [
            {
                name: 'phone_number',
                placeholder: t('enter_number')
            }
        ];
    }

    return [];
};

export default getFormFields;
